import WithdrawApprovalDetailPage from './WithdrawApprovalDetailPage';

export default WithdrawApprovalDetailPage;
